module.exports = __webpack_public_path__ + "img/product_mb_new_01.3b5b41e.svg";